import axios from "../../config/axios";
import {
  FETCH_SURVEYOR_MANAGEMENT_FAILURE,
  FETCH_SURVEYOR_MANAGEMENT_REQUEST,
  FETCH_SURVEYOR_MANAGEMENT_SUCCESS,
} from "./types";

export const fetchSurveyorManagementDetailSuccess = (model) => {
  return {
    type: FETCH_SURVEYOR_MANAGEMENT_SUCCESS,
    payload: model,
  };
};
export const fetchSurveyorManagementDetailFailure = (error) => {
  return {
    type: FETCH_SURVEYOR_MANAGEMENT_FAILURE,
    payload: error,
  };
};

export const getSurveyorManagementDetail = (currentPage, pagelimit) => async (dispatch) => {
  // dispatch(fetchCATTLEDetailRequest);
  await axios
    .post(`surveyor/listSurveyor/?page=${currentPage}&limit=${pagelimit}`)
    .then((response) => {
      if (response.status) {
        const result = response.data;
        dispatch(fetchSurveyorManagementDetailSuccess(result));
      }
    })
    .catch((error) => {
      const errorMsg = error.message;
      dispatch(fetchSurveyorManagementDetailFailure(errorMsg));
    });
};